import { useRef, useEffect } from 'react';

function usePersistentRef<T>(
  path: string[],
  key: string,
  initialValue: T,
): React.MutableRefObject<T> {
  const storageKey = `${path.join('/')}/${key}`;

  const storedValue = localStorage.getItem(storageKey);
  const ref = useRef<T>(storedValue !== null ? JSON.parse(storedValue) : initialValue);

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(ref.current));
  }, [storageKey, ref.current]);

  return ref;
}

export default usePersistentRef;
